var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.469,
    height: 21.469,
    viewBox: "0 0 21.469 21.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_661",
    "data-name": "Rectangle 661",
    width: 21.469,
    height: 21.469,
    fill: "#212327"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1585",
    "data-name": "Group 1585",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M9.656,11.813h-8.3a2.619,2.619,0,0,1-.459-.023A1.07,1.07,0,0,1,.9,9.677a2.787,2.787,0,0,1,.46-.02H9.656V9.12q0-3.879,0-7.757a2.556,2.556,0,0,1,.029-.5A1.067,1.067,0,0,1,11.779.854a2.469,2.469,0,0,1,.032.5q0,3.879,0,7.757v.545h.526q3.9,0,7.8,0a2.169,2.169,0,0,1,.579.062,1.059,1.059,0,0,1-.012,2.031,2.26,2.26,0,0,1-.579.059q-3.879.005-7.757,0h-.555v.515q0,3.9,0,7.8a2.269,2.269,0,0,1-.048.539,1.061,1.061,0,0,1-2.056.008,2.224,2.224,0,0,1-.049-.539q0-3.879,0-7.757v-.565",
    transform: "translate(0 0)",
    fill: "#212327"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.aecd086491e02073fbe2e5daf5e9ded1.svg";
export { ForwardRef as ReactComponent };